import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Checkbox } from 'primeng/checkbox';
import { AddressFormModel } from './form-group/address-form.model';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormDomesticAddressComponent } from '../form-domestic-address/form-domestic-address.component';
import { FormForeignAddressComponent } from '../form-foreign-address/form-foreign-address.component';
import { AddressFormBuilder } from './form-group/address.form.builder';

@Component({
  selector: 'app-form-address',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    Checkbox,
    FormDomesticAddressComponent,
    FormForeignAddressComponent,
  ],
  templateUrl: './form-address.html',
  styleUrl: './form-address.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormAddress implements OnInit {
  public formGroup = input.required<FormGroup<AddressFormModel>>();
  public schoolAddress = input<boolean>(false);
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    AddressFormBuilder.switchDomesticOrForeignGroup(this.formGroup(), true);
    this.#subscribeToCzyAdresZagranicznyControl();
  }

  #subscribeToCzyAdresZagranicznyControl(): void {
    this.formGroup()
      ?.controls.czyAdresZagraniczny.valueChanges.pipe(
        tap(() =>
          AddressFormBuilder.switchDomesticOrForeignGroup(this.formGroup()),
        ),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe();
  }
}
